exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.back-to-ceiling[data-v-787a82f6] {\r\n  position: fixed;\r\n  display: inline-block;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  z-index: 9999;\n}\n.back-to-ceiling[data-v-787a82f6]:hover {\r\n  background: #d5dbe7;\n}\n.fade-enter-active[data-v-787a82f6],\r\n.fade-leave-active[data-v-787a82f6] {\r\n  -webkit-transition: opacity .5s;\r\n  transition: opacity .5s;\n}\n.fade-enter[data-v-787a82f6],\r\n.fade-leave-to[data-v-787a82f6] {\r\n  opacity: 0\n}\n.back-to-ceiling .Icon[data-v-787a82f6] {\r\n  fill: #9aaabf;\r\n  background: none;\n}\r\n", ""]);

// exports
